module.exports = __webpack_public_path__ + "static/media/edit.d021f095.svg";